import { environment } from '../../../../environments/environment';

export function UserUsernameAvailableValidatorDirective($q, $http) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.userUsernameAvailable = function (modelValue) {
        if (modelValue !== attrs.userUsernameAvailableValidator) {
          return $http.get(
            environment.apiEndpoint + 'sessions/check_user_username?q=' + modelValue
          );
        }

        return $q.resolve(true);
      };
    },
  };
}

UserUsernameAvailableValidatorDirective.$inject = ['$q', '$http'];
